import { TTaxResidencyAdditionalInformation } from '~/modules/identification/forms/TaxResidencyAdditionalInformation/types.ts';

export const optionAccountHolderStatus = {
  option1: 'FI_INVESTMENT_ENTITY_MANAGED',
  option2: 'FI_OTHER_INVESTMENT_ENTITY',
  option3: 'FI_DEPOSITORY_CUSTODIAL_INSURANCE',
  option4: 'ACTIVE_NFE_PUBLIC_COMPANY',
  option5: 'ACTIVE_NFE_GOVERNMENT',
  option6: 'ACTIVE_NFE_INTERNATIONAL_ORG',
  option7: 'ACTIVE_NFE_OTHER',
  option8: 'PASSIVE_NFE',
};

export const optionAccountHolderStatusMap = [
  {
    value: optionAccountHolderStatus.option1,
    label:
      'Фінансова Установа — Інвестиційна Компанія, яка не є ФУ Юрисдикції - Учасниці та яка перебуває під управлінням іншої ФУ',
  },
  {
    value: optionAccountHolderStatus.option2,
    label: 'Фінансова Установа — Інша Інвестиційна Компанія',
  },
  {
    value: optionAccountHolderStatus.option3,
    label:
      'Фінансова Установа - Депозитарна Установа, Кастодіальна Установа або Визначена Страхова Компанія',
  },
  {
    value: optionAccountHolderStatus.option4,
    label: "Активна НФО — публічна компанія або її Пов'язана Організація",
  },
  {
    value: optionAccountHolderStatus.option5,
    label: 'Активна НФО — Урядова Організація або Центральний Банк',
  },
  {
    value: optionAccountHolderStatus.option6,
    label: 'Активна НФО — Міжнародна Організація',
  },
  {
    value: optionAccountHolderStatus.option7,
    label: 'Активна НФО — інша (напр., новостворена або неприбуткова)',
  },
  {
    value: optionAccountHolderStatus.option8,
    label: 'Пасивна НФО',
  },
];

export const tinUnavailableReasonMap = [
  {
    value: 'A',
    label: 'юрисдикція не присвоює ІПН',
  },
  {
    value: 'B',
    label: 'не вдалось отримати ІПН',
  },
  {
    value: 'C',
    label: 'ІПН не вимагається',
  },
];

export const controllingPersonStatusMap = [
  {
    value: 'CP_LEGAL_PERSON_OWNERSHIP',
    label: 'КО юридичної особи - право власностi (CP of legal person - ownership)',
  },
  {
    value: 'CP_LEGAL_PERSON_OTHER_MEANS',
    label: 'КО юридичної особи - iнший спосiб контролю (CP of legal person - other means)',
  },
  {
    value: 'CP_LEGAL_PERSON_SENIOR_MANAGING_OFFICIAL',
    label:
      'КО юридичної особи - особа, яка займає старшу керiвну посаду (CP of legal person - senior managing official)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_TRUST_SETTLOR',
    label: 'КО правового утворення - траст - засновник (CP of legal arrangement - trust - settlor)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_TRUST_TRUSTEE',
    label:
      'КО правового утворення - траст - управитель (довiрчий власник) (CP of legal arrangement - trust - trustee)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_TRUST_PROTECTOR',
    label:
      'КО правового утворення - траст - захисник (протектор) (CP of legal arrangement - trust - protector)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_TRUST_BENEFICIARY',
    label:
      'КО правового утворення - траст - вигодонабувач (бенефiцiар) (CP of legal arrangement - trust - beneficiary)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_TRUST_OTHER',
    label: 'КО правового утворення - траст - iнше (CP of legal arrangement - trust - other)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_OTHER_SETTLOR_EQUIVALENT',
    label:
      'КО правового утворення - iнше - еквiвалент засновника (CP of legal arrangement - other - settlor-equivalent)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_OTHER_TRUSTEE_EQUIVALENT',
    label:
      'КО правового утворення - iнше - еквiвалент управителя (довiрчого власника) (CP of legal arrangement - other - trustee-equivalent)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_OTHER_PROTECTOR_EQUIVALENT',
    label:
      'КО правового утворення - iнше - еквiвалент захисника (протектора) (CP of legal arrangement - other - protectorequivalent)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_OTHER_BENEFICIARY_EQUIVALENT',
    label:
      'КО правового утворення - iнше - еквiвалент вигодонабувача (бенефiцiара) (CP of legal arrangement - other - beneficiary-equivalent)',
  },
  {
    value: 'CP_LEGAL_ARRANGEMENT_OTHER_OTHER_EQUIVALENT',
    label:
      'КО правового утворення - iнше - iнший еквiвалент (CP of legal arrangement - other - other-equivalent)',
  },
];

export const EMPTY_TAX_RESIDENCY_JURISDICTIONS = {
  jurisdictionCountry: null,
  tin: null,
  tinUnavailableReason: null,
  tinUnavailableExplanation: null,
};

export const EMPTY_CONTROLLING_PERSONS = {
  id: null,
  lastName: null,
  firstName: null,
  middleName: null,
  salutation: null,
  isTaxResidentOtherJurisdiction: null,
  taxResidencies: null,
  organizations: null,
};

export const EMPTY_ORGANIZATIONS = {
  name: null,
  controllingPersonStatus: null,
  accounts: null,
};

export const EMPTY_ACCOUNTS = {
  iban: null,
  openDate: null,
  bankMFO: null,
};

export const showAccountHolderStatusGiin = [
  optionAccountHolderStatus.option1,
  optionAccountHolderStatus.option2,
  optionAccountHolderStatus.option3,
];

export const showBeneficiaryOwners = [
  optionAccountHolderStatus.option1,
  optionAccountHolderStatus.option8,
];

export const titleBlockOrganizations =
  'Будь ласка, вкажіть юридичне найменування відповідного (-их) власника (-ів) рахунку (-ів) - Організації (-й), щодо якої (-их) КБВ є Контролюючою Особою';

export const tooltipBlockOrganizations =
  'Якщо кінцевий бенефіціарний власник (КБВ) є Контролюючою Особою інших організацій, що обслуговуються у нашому банку - вкажіть їх нижче';

export const tooltipSecuritiesMarketName =
  'Вкажіть назву організованого ринку цінних паперів, на якому акції організації (публічної компанії) перебувають у регулярному обігу';

export const tooltipPublicCompanyName =
  "Якщо ви Пов'язана Організація публічної компанії, будь ласка, вкажіть назву цієї публічної компанії, для якої ваша Організація в пункті 3 є Пов’язаною Особою";

export const accountTableColumns = [
  {
    title: 'Номер рахунку',
    size: 6,
  },
  {
    title: 'Дата відкриття рахунку',
    size: 5,
  },
  {
    title: 'Дії',
    size: 1,
  },
];

export const testDataTaxResidencyAdditionalInformation: TTaxResidencyAdditionalInformation = {
  organizationName: 'ПРАТ "ВФ УКРАЇНА"',
  registrationJurisdiction: 'Україна',
  accountHolderStatus: {
    selectedOption: 'PASSIVE_NFE',
    giin: null,
    securitiesMarketName: null,
    publicCompanyName: null,
  },
  taxResidencies: [
    {
      jurisdictionCountry: { value: '724', label: 'Іспанія' },
      tin: null,
      tinUnavailableReason: 'A',
      tinUnavailableExplanation: null,
    },
  ],
  controllingPersons: [
    {
      id: 'e58b4550-b131-41f9-896a-18e6834b356c',
      lastName: 'Бондаренко',
      firstName: 'Юлія',
      middleName: 'Едуардівна',
      salutation: null,
      isTaxResidentOtherJurisdiction: true,
      taxResidencies: [
        {
          jurisdictionCountry: { value: '442', label: 'Люксембург' },
          tin: '666',
          tinUnavailableReason: null,
          tinUnavailableExplanation: null,
        },
      ],
      organizations: [
        {
          name: 'ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО "ВФ УКРАЇНА"',
          controllingPersonStatus: null,
          accounts: null,
        },
      ],
    },
    {
      id: '7f181cab-b07b-4531-917f-06994233e5f3',
      lastName: 'БОНДАРЕНКО',
      firstName: 'ІГОР',
      middleName: 'ЕДУАРДОВИЧ',
      salutation: null,
      isTaxResidentOtherJurisdiction: true,
      taxResidencies: [
        {
          jurisdictionCountry: { value: '703', label: 'Словаччина' },
          tin: null,
          tinUnavailableReason: 'C',
          tinUnavailableExplanation: '123',
        },
      ],
      organizations: [
        {
          name: 'ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО "ВФ УКРАЇНА"',
          controllingPersonStatus: null,
          accounts: null,
        },
      ],
    },
  ],
};
